<div class="share-list-modal">
    <div class="modal-header">
        <h4 class="modal-title" translate="cart.create.sharelist.modal.title"></h4>
        <button type="button" class="close fa-solid fa-xmark" [attr.aria-label]="'cart.button.close'" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <form class="dsm-form">
            <label translate="cart.create.sharelist.modal.label"></label>
            <input type="text" name="shareListName" [(ngModel)]="shareList.listName" />
        </form>
    </div>
    <div class="modal-footer margin-top-10 word-wrap">
        <button type="button" class="button button-tertiary" (click)="saveShareList(false)" translate="cart.create.sharelist.modal.save"></button>
        <button type="button" class="button button-primary" (click)="saveShareList(true)" translate="cart.create.sharelist.modal.enroll"></button>
    </div>
</div>
